
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/profile",
      function () {
        return require("private-next-pages/account/profile.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/profile"])
      });
    }
  